/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import KImage from '@/types/KImage'

class Offer {
  private json: any
  public readonly uid: string;
  public readonly description: string;
  public readonly logo: KImage;
  public readonly getOfferText: string;
  public readonly getOfferUrl: string;
  public readonly expiresLabel: string;
  public readonly expiresDate: number;

  constructor (json: any, getOfferText: string, offersPageUrl: string, expiresLabel: string) {
    this.uid = json.uid
    this.logo = new KImage(json.image.url, json.image.content_type, json.image_alt)
    this.description = json.special_offer_title
    this.getOfferText = getOfferText
    this.getOfferUrl = offersPageUrl
    this.expiresDate = json.end_date
    this.expiresLabel = expiresLabel
  }

  static of (json: any, getOfferText: string, offersPageUrl: string, expiresLabel: string): Offer {
    return new Offer(json, getOfferText, offersPageUrl, expiresLabel)
  }
}

export default Offer
